var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMoBk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 14,
    viewBox: "0 0 184 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_10682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1803 0.195801H25.1758V13.8341H27.1803V0.195801Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1976 5.99805L27.9629 7.01527L32.1976 8.03249V5.99805Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2953 0.195801H28.1914C31.0534 0.583852 32.9075 1.33358 34.2953 2.4676V0.195801Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5163 0.195801H37.5117V13.8341H39.5163V0.195801Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6534 13.8341L42.3581 5.72266L41.0117 7.07142L45.4232 13.8341H47.6534Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7195 0.195801C44.7195 0.195801 44.5239 2.0268 43.2227 4.85619L47.8748 0.195801H44.7232H44.7195Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2953 11.5059C32.9075 12.6436 31.0534 13.4461 28.1914 13.8342H34.2953V11.5059Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.233 0.195801H162.229V13.8341H164.233V0.195801Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.173 0.195801H164.85C168.674 0.546178 170.818 3.21356 170.818 7.00743C170.818 10.8013 168.697 13.4837 164.85 13.8341H166.173C169.942 13.8341 172.954 11.016 172.954 7.00743C172.954 2.99881 170.119 0.195801 166.173 0.195801Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.333 0.195801H149.332V13.8304H151.333V0.195801Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.667 3.61668C158.667 0.55748 155.301 0.195801 154.225 0.195801H152.42C153.123 0.342733 156.542 0.719482 156.542 3.63175C156.542 7.23724 152.589 7.35404 152.589 7.35404C153.251 7.35404 153.872 7.68181 154.248 8.22809C156.444 11.4493 155.214 9.64467 157.824 13.8228H160.156L155.842 7.28622C157.072 7.01119 158.667 5.85081 158.667 3.62045V3.61668Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.26 2.88245C176.26 1.63918 177.087 0.644564 178.569 0.128418C176.369 0.18493 174.586 1.54123 174.586 3.49656C174.586 8.80495 182.288 6.04338 182.288 10.5568C182.288 12.0864 181.461 13.3297 179.678 13.9061C182.157 13.8496 183.999 12.2032 183.999 9.82971C183.999 4.42336 176.26 7.09451 176.26 2.88622V2.88245Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.285 2.95404V0.32056C182.533 0.331863 180.701 0.256513 179.848 0.128418C179.848 0.128418 182.07 0.633262 183.285 2.95404Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.549 10.9971V13.7134L178.306 13.9056C176.049 13.2237 175.113 11.7129 174.549 10.9971Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.379 12.7302L136.046 0.195801H134.015L131.379 12.7302Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.101 0.195801L125.747 2.24908L123.762 12.9073L126.669 5.16512L129.399 13.8341H131.479L127.203 0.195801H125.101Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.967 0.195801L121.807 13.8341H123.909L119.047 0.195801H116.967Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00454 0.195801H0V13.8341H2.00454V0.195801Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9284 3.66203C6.9284 6.80789 3.46841 7.00003 2.93436 7.01887C3.51354 7.01133 7.41731 7.01887 7.41731 10.3682C7.41731 13.7175 3.01334 13.8343 2.81026 13.8343H4.26947C8.35 13.8343 9.52715 12.2293 9.52715 10.3192C9.52715 8.65773 8.41393 7.3278 5.50303 6.9925C7.70313 6.58937 8.93669 5.30466 8.93669 3.71478C8.93669 1.80466 7.49252 0.199707 4.26947 0.199707H2.80273C3.50601 0.335337 6.92463 0.489804 6.92463 3.6658L6.9284 3.66203Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.876 13.8341L76.9703 0.195801H74.6348L83.5405 13.8341H85.876Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0371 13.8343H78.2752C76.2594 12.429 75.0371 7.01514 75.0371 7.01514V13.8343Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.492 7.01496V0.195801H82.2539C84.2697 1.60108 85.492 7.01496 85.492 7.01496Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3949 13.3067V7.01123H95.4648C95.4648 7.01123 97.4882 7.6404 97.4882 9.71629V13.3255C97.7928 13.2502 98.8722 13.0241 99.3949 13.3067Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2067 13.6948C92.5511 13.9284 90.1065 11.5511 90.1065 6.85684C90.1065 3.3493 91.1107 0.738428 94.1043 0C90.43 0 87.7598 3.07804 87.7598 7.0113C87.7598 12.0748 91.8704 14.9795 96.2067 13.6948Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3136 2.8746V0.19591C98.5351 0.207212 96.6397 0.128095 95.7559 0C95.7559 0 98.3659 0.678149 99.3136 2.8746Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1855 11.0234V13.7586L53.9426 13.9508C51.6861 13.2613 50.7497 11.743 50.1855 11.0234Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9218 2.92356V0.271244C58.1696 0.282546 56.3381 0.207196 55.4844 0.0791016C55.4844 0.0791016 57.707 0.587713 58.9218 2.92356Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8923 2.85588C51.8923 1.60507 52.7197 0.602922 54.2015 0.0830078C52.0014 0.13952 50.2188 1.50712 50.2188 3.47375C50.2188 8.81982 57.921 6.03941 57.921 10.583C57.921 12.1239 57.0936 13.3785 55.311 13.9549C57.7894 13.8984 59.6322 12.2407 59.6322 9.85211C59.6322 4.40809 51.8923 7.09808 51.8923 2.85965V2.85588Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1421 3.15723L10.7344 13.8343H13.1601L15.1421 3.15723Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1766 10.0214L20.5343 13.8341H22.6366L17.7738 0.195801H15.6715L18.6464 8.5408L15.3594 9.22648L19.1766 10.0214Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2163 3.15723L60.8086 13.8343H63.2343L65.2163 3.15723Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2528 10.0214L70.6105 13.8341H72.7128L67.85 0.195801H65.7477L68.7225 8.5408L65.4355 9.22648L69.2528 10.0214Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.103 0.195801L113.082 8.5408L109.791 9.22648L113.608 10.0214L114.966 13.8341H117.068L112.205 0.195801H110.103Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.59 13.8343L109.572 3.15723L105.164 13.8343H107.59Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.363 0.195801L143.342 8.5408L140.051 9.22648L143.868 10.0214L145.226 13.8341H147.328L142.465 0.195801H140.363Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.85 13.8343L139.832 3.15723L135.424 13.8343H137.85Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_10682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMoBk);
export default __webpack_public_path__ + "static/media/logo_mo_bk.628b74c04bac7335917bb2cdf1d2c035.svg";
export { ForwardRef as ReactComponent };